export let ffmpeg;
export let util;
export let FFmpeg;
export let fetchFile, toBlobURL;
export type CBProgressParams = {progress: number; time: number};
export type CBProgressCallback = (progress: CBProgressParams) => void;
export type LogsProgressCallback = (line: string) => void;
import {Platform} from 'react-native';
import {ffMpegWasmBaseUrl} from '../db/defaults';
export const cancelEncoding = () => {
  try {
    ffmpeg.terminate();
  } catch (err) {
    // console.error('terminate ffmpeg error', err)
  }
};
export const createFFmpeg = async (
  cb?: CBProgressCallback,
  logsCB?: LogsProgressCallback,
) => {
  if (Platform.OS === 'web') {
    if (!FFmpeg) {
      util = await import('@ffmpeg/util');
      fetchFile = util.fetchFile;
      toBlobURL = util.toBlobURL;
      FFmpeg = (await import('@ffmpeg/ffmpeg')).FFmpeg;
    }
    ffmpeg = new FFmpeg();
    // ffmpeg.mount("NODEFS", {} as WorkerFSMountData, "/")
    window.ffmpeg = ffmpeg;
    ffmpeg.on('log', ({message}: {message: string}) => {
      console.log('ffmpeg', message);
      if (logsCB) logsCB(message);
    });
    ffmpeg.on('progress', (params: CBProgressParams) => {
      console.info('ffmpeg progress', params);
      if (cb) cb(params || 0);
    });
    await ffmpeg.load({
      coreURL: await toBlobURL(
        `${ffMpegWasmBaseUrl}/ffmpeg-core.js`,
        'text/javascript',
      ),
      wasmURL: await toBlobURL(
        `${ffMpegWasmBaseUrl}/ffmpeg-core.wasm`,
        'application/wasm',
      ),
    });
  }
};
